import { Route, Routes, useLocation, useNavigate, matchPath } from "react-router-dom"
import Main from "../components/Layout/Main"
import { homePageRoute, privateRoutes } from "./routes"
import ProtectedRoute from "./ProtectedRoute"
import { RoutePaths } from "./RoutePaths.enum"
import CategoriesView from "../pages/categories/CategoriesView"
import { useEffect } from "react"
import { useContainerInjection } from "../hooks/useContainerInjection"
import { AuthStore } from "../stores/AuthStore"
import { Roles } from "../../domain/enum/roles.enum"
import TransactionsView from "../pages/transactions/TransactionsView"

const PrivateRoutes = () => {
	const location = useLocation()
	const navigate = useNavigate()
	const { userData } = useContainerInjection<AuthStore>("AuthStore")
	const hasAdminRole = userData?.roles?.includes(Roles.ADMIN)

	const allowedRoutes = privateRoutes.filter(r =>
		r.roles.reduce((allowed, role) => allowed || (userData?.roles?.includes(role) ?? false), false)
	)

	useEffect(() => {
		const isValidRoute = allowedRoutes.some(r => matchPath(r.path, location.pathname))
		const isValidStaticRoute = Object.values(RoutePaths).some(path => matchPath(path, location.pathname))

		if (!isValidRoute && !isValidStaticRoute) {
			console.warn(`Route "${location.pathname}" not found or not allowed.`)
			navigate(homePageRoute, { replace: true })
		}
	}, [location.pathname, allowedRoutes, navigate])
	return (
		<div>
			<Main>
				<Routes>
					{allowedRoutes.map(route => (
						<Route
							key={route.path}
							path={route.path}
							index={route?.index}
							element={
								<ProtectedRoute>
									<route.Component />
								</ProtectedRoute>
							}
						/>
					))}
					<Route path="*" element={hasAdminRole ? <CategoriesView /> : <TransactionsView />} />
				</Routes>
			</Main>
		</div>
	)
}

export default PrivateRoutes
